export const EXPORT_JOB_STATUS = {
    PENDING: 0,
    PROCESSING: 1,
    READY: 2,
    ERROR: 3,
    EXPIRED: 4,
};

export const EXPORT_JOB_TYPE = {
    AUDIT_TRAIL: 1,
    PRESCRIPTIONS: 2,
    DISPENSATIONS: 3,
    PATIENTS: 4,
    INSTITUTIONS: 5,
};

export const EXPORT_STATUS_COLOR = {
    [EXPORT_JOB_STATUS.PENDING]: "default",
    [EXPORT_JOB_STATUS.PROCESSING]: "info",
    [EXPORT_JOB_STATUS.READY]: "success",
    [EXPORT_JOB_STATUS.ERROR]: "error",
    [EXPORT_JOB_STATUS.EXPIRED]: "warning",
};

/** Poll interval while there are active (pending/processing) jobs. */
export const POLL_INTERVAL_MS = 10000;
